import { useEffect } from 'react';
import { useNavigate } from 'react-router';

const useAuth = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const jwt = localStorage.getItem('jwt');
    const disclaimerAccepted = localStorage.getItem('disclaimerAccepted');
    
    if (!jwt) {
      navigate('/login');
      return;
    }
    
    if (disclaimerAccepted !== 'true') {
      navigate('/disclaimer');
      return;
    }
  }, [navigate]);

  // Simply return true since we handle navigation for non-logged-in cases
  return true;
};

export default useAuth; 